
document.addEventListener('DOMContentLoaded', () => {
  // Configuration for specific product recommendations
  const PRODUCT_SPECIFIC_RECOMMENDATIONS = {
    '42301525229737': [7515285127337, 7549663281321, 7549668196521],
    '7515280015529': [7515285127337, 7549663281321, 7549668196521]
  };

  // Select all valid forms for adding to cart
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

  addToCartForms.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      try {
        const formData = new FormData(form);
        const currentProductId = form.querySelector('[name="id"]')?.value;

        if (!currentProductId) {
          throw new Error('No product ID found');
        }

        // Check if we have specific recommendations for this product
        const specificRecommendations = PRODUCT_SPECIFIC_RECOMMENDATIONS[currentProductId];
        
        if (specificRecommendations && specificRecommendations.length > 0) {
          // First verify if products exist before fetching details
          const validProducts = await verifyProducts(specificRecommendations);
          
          if (validProducts.length > 0) {
            // Now fetch full details for valid products
            const recommendedProducts = await fetchSpecificProducts(validProducts);
            
            if (recommendedProducts.length > 0) {
              showRecommendedProductsPopup(recommendedProducts);
              return;
            }
          }
        }

        // If no recommendations or products not found, proceed with cart addition
        await addToCart(formData);

      } catch (error) {
        console.error('Error in form submission:', error);
        // Fallback to normal form submission
        form.submit();
      }
    });
  });

  // Function to verify products exist before fetching details
 async function verifyProducts(productIds) {
    const validProducts = [];

    for (const productId of productIds) {
        try {
            const response = await fetch(`/products/${productId}`).then((e)=>{
                console.log("API response", e)
              console.log(e.ok);
                   if (e.ok) {
              console.log("error");
                validProducts.push(productId);
            } else {
                console.warn(`Product ${productId} not found - status: ${e.status}`);
            }
       
            });
     
       
        } catch (error) {
            console.warn(`Error verifying product ${productId}:`, error);
        }
    }
    
    if (validProducts.length === 0) {
        console.warn('No valid products found for recommendations.');
    }

    return validProducts;
}

async function fetchSpecificProducts(productIds) {
    const products = [];
    
    for (const productId of productIds) {
        try {
            const response = await fetch(`/products/${productId}`);
            if (response.ok) {
                const product = await response.json();
                products.push(product);
            } else {
                console.warn(`Could not fetch product ${productId} - status: ${response.status}`);
            }
        } catch (error) {
            console.warn(`Error fetching product ${productId}:`, error);
        }
    }
    
    return products;
}

  // Function to add to cart
  async function addToCart(formData) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/javascript'
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      // Optional: Update cart count or show cart drawer
      const cart = await fetch('/cart.js').then(res => res.json());
      updateCartCount(cart.item_count);

    } catch (error) {
      console.error('Error adding to cart:', error);
      throw error;
    }
  }

  // Function to update cart count
  function updateCartCount(count) {
    const cartCount = document.querySelector('.cart-count-bubble');
    if (cartCount) {
      cartCount.textContent = count;
    }
  }

  function showRecommendedProductsPopup(products) {
    const existingPopup = document.getElementById('recommended-products-popup');
    if (existingPopup) {
      existingPopup.remove();
    }

    const popup = document.createElement('div');
    popup.id = 'recommended-products-popup';
    popup.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    `;

    popup.innerHTML = `
      <div style="background: white; padding: 20px; border-radius: 8px; max-width: 800px; width: 90%; max-height: 80vh; overflow-y: auto;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
          <h2 style="margin: 0; font-size: 1.5em;">Recommended Products</h2>
          <button id="close-recommended-popup" style="background: none; border: none; font-size: 24px; cursor: pointer;">&times;</button>
        </div>
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 20px;">
          ${products.map(product => `
            <div style="text-align: center; border: 1px solid #eee; padding: 10px; border-radius: 8px;">
              <img 
                src="${product.featured_image || product.images[0]}" 
                alt="${product.title}"
                style="width: 100%; height: 200px; object-fit: cover; margin-bottom: 10px;"
              >
              <h3 style="margin: 10px 0; font-size: 1em;">${product.title}</h3>
              <p style="margin: 10px 0; font-weight: bold;">${(product.price / 100).toFixed(2)}</p>
              <a 
                href="${product.url}"
                style="display: inline-block; background: #007bff; color: white; padding: 8px 15px; text-decoration: none; border-radius: 4px;"
              >
                View Product
              </a>
            </div>
          `).join('')}
        </div>
      </div>
    `;

    document.body.appendChild(popup);

    const closeButton = popup.querySelector('#close-recommended-popup');
    closeButton.addEventListener('click', () => popup.remove());

    popup.addEventListener('click', (event) => {
      if (event.target === popup) {
        popup.remove();
      }
    });
  }
});